import REDUX_ASSOCIATION from '../../constants/association'
import REDUX_NON_SAVABLE_ASSOCIATION from '../../constants/non-savable-association'
import getClassNameReduxUtil from '../get-class-name'
import getLocalKeysReduxUtil from '../get-local-keys'
import getUpdatedDataReduxUtil from '../get-updated-data'

export default function getAssociationKeysReduxUtil (instance) {
  if (!instance) {
    return []
  }
  const className = getClassNameReduxUtil(instance)
  const association = REDUX_ASSOCIATION[className] || []
  const localKeys = getLocalKeysReduxUtil(instance)
  return association.filter(a => !localKeys.includes(a))
}

export function getForeignKeyReduxUtil (instance) {
  const data = getUpdatedDataReduxUtil(instance)
  return Object
    .keys(data)
    .filter(key => !key.startsWith('exercise') && key.endsWith('Id'))
}

export function getAssociationAndForeignKeys (instance) {
  return [
    ...getAssociationKeysReduxUtil(instance),
    ...getForeignKeyReduxUtil(instance)
  ]
}

export function getSavableAssociationKeysReduxUtil (instance) {
  const associationKeys = getAssociationKeysReduxUtil(instance)
  const nonSavableAssociationKeys = [
    ...getLocalKeysReduxUtil(instance),
    ...(
      REDUX_NON_SAVABLE_ASSOCIATION[getClassNameReduxUtil(instance)] || []
    )
  ]
  return (
    associationKeys.filter(associationKey => !nonSavableAssociationKeys.includes(
      associationKey))
  )
}

export function getSavableAssociationAndForeignKeys (instance) {
  return [
    ...getSavableAssociationKeysReduxUtil(instance),
    ...getForeignKeyReduxUtil(instance)
  ]
}
